/**
 * Eksport layoutu formularza do pliku — wywołanie trasy `…/layouts/[layoutId]/form-export`
 * i zapis odpowiedzi jako plik JSON w przeglądarce.
 *
 * `endpointBase` = baza tras layoutów kartoteki: `/system-modules/<slug>/layouts` (kartoteki
 * systemowe i klasy dokumentów) albo `/modules/<id>/layouts` (kartoteki własne).
 *
 * Pomocnik pobierania jest lokalny celowo — równoległy nurt eksportu menu ma własny; wspólny
 * wyciągniemy po scaleniu obu.
 */

import type { FormExportFile } from '@saas/shared';

import { api } from '@/lib/api';

function downloadJson(data: unknown, fileName: string): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** Nazwa pliku z nagłówka `Content-Disposition` (serwer składa bezpieczną nazwę). */
function fileNameFromHeader(header: unknown): string | null {
  if (typeof header !== 'string') return null;
  const match = /filename="([^"]+)"/.exec(header);
  return match?.[1] ?? null;
}

export async function exportFormLayout(endpointBase: string, layoutId: string): Promise<void> {
  const res = await api.get<FormExportFile>(`${endpointBase}/${layoutId}/form-export`);
  const name =
    fileNameFromHeader(res.headers['content-disposition']) ?? 'layout-formularza-eksport.json';
  downloadJson(res.data, name);
}
